(function(){
  function initChart(root){
    var D; try{D=JSON.parse(root.querySelector('[data-idx-data]').textContent);}catch(e){return;}
    var svg=root.querySelector('[data-idx-svg]'), numEl=root.querySelector('[data-idx-num]'), dEl=root.querySelector('[data-idx-delta]');
    var isLight=root.classList.contains('is-light');
    var lineColor=isLight?'#296040':'#6FCF97';
    var fillTop=isLight?'rgba(41,96,64,.16)':'rgba(111,207,151,.22)';
    var gridColor=isLight?'rgba(26,26,26,.07)':'rgba(255,255,255,.06)';
    function draw(key){
      var s=D[key]; if(!s||!svg)return;
      var d=s.pts, min=Math.min.apply(null,d)-4, max=Math.max.apply(null,d)+3, W=600,H=160,p=6;
      var pts=d.map(function(v,i){return [p+i/(d.length-1)*(W-p*2), H-p-((v-min)/(max-min))*(H-p*2-16)];});
      var line=pts.map(function(pt,i){return (i?'L':'M')+pt[0].toFixed(1)+' '+pt[1].toFixed(1);}).join(' ');
      var area=line+' L'+pts[pts.length-1][0].toFixed(1)+' '+H+' L'+pts[0][0].toFixed(1)+' '+H+' Z';
      svg.innerHTML='<defs><linearGradient id="rrg" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="'+fillTop+'"/><stop offset="1" stop-color="transparent"/></linearGradient></defs>'
        +[0,1,2].map(function(i){return '<line x1="0" x2="'+W+'" y1="'+(p+i*(H-p*2)/2)+'" y2="'+(p+i*(H-p*2)/2)+'" stroke="'+gridColor+'"/>';}).join('')
        +'<path d="'+area+'" fill="url(#rrg)"/><path d="'+line+'" fill="none" stroke="'+lineColor+'" stroke-width="2"/>'
        +'<circle cx="'+pts[pts.length-1][0].toFixed(1)+'" cy="'+pts[pts.length-1][1].toFixed(1)+'" r="3" fill="'+lineColor+'"/>';
      if(numEl)numEl.textContent=d[d.length-1].toFixed(1);
      if(dEl)dEl.textContent=s.delta;
    }
    [].forEach.call(root.querySelectorAll('[data-idx-tabs] button'),function(b){b.addEventListener('click',function(){
      [].forEach.call(root.querySelectorAll('[data-idx-tabs] button'),function(x){x.classList.toggle('on',x===b);}); draw(b.dataset.range);});});
    draw('5y');
  }

  function init(root){
    if(!root||root.dataset.rowInit)return; root.dataset.rowInit='1';
    initChart(root);
  }
  function all(){[].forEach.call(document.querySelectorAll('[data-hdb-resale-row]'),init);}
  if(document.readyState!=='loading')all(); else document.addEventListener('DOMContentLoaded',all);
  document.addEventListener('shopify:section:load',function(e){var el=e.target.querySelector('[data-hdb-resale-row]'); if(el){el.dataset.rowInit=''; init(el);}});
})();
